import { Box } from "@mui/material";
import { FadeLoader } from "react-spinners";

const AppLoadingDataTable = () => {
  return (
    <Box className="px-5 py-10 pt-[100px] text-center w-full col-span-full">
      <FadeLoader color="#1876f2" className="mx-auto" />
      <br /> Đang tải dữ liệu...
    </Box>
  );
};

export default AppLoadingDataTable;
